module.exports = __webpack_public_path__ + "static/media/Page19.d36f36ec.png";